import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { resetAll } from "./actions/resetAll"

// Cache para timestamps ISO
const timestampCache = {
    value: null as string | null,
    update() {
        this.value = new Date().toISOString()
        return this.value
    }
}

export type TotalizadorRedux = {
    desabilitarEdicoes: boolean,
    ultimaAtualizacao: string | null
}

const initialState: TotalizadorRedux = {
    desabilitarEdicoes: false,
    ultimaAtualizacao: null
}

export const totalizadorSlice = createSlice({
    name: "totalizador",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => {
        timestampCache.value = null // Limpa cache no reset
        return initialState
    }),
    reducers: {
        desabilitarEdicoes: (state, action: PayloadAction<boolean>) => {
            // Só atualiza se o valor mudou
            if (state.desabilitarEdicoes !== action.payload) {
                state.desabilitarEdicoes = action.payload
            }
        },
        registrarAtualizacao: (state) => {
            // Atualiza apenas se necessário e usa cache
            const newTimestamp = timestampCache.update()
            if (state.ultimaAtualizacao !== newTimestamp) {
                state.ultimaAtualizacao = newTimestamp
            }
        }
    }
})

export default totalizadorSlice.reducer

export const {
    desabilitarEdicoes: desabilitarEdicoesAction,
    registrarAtualizacao: registrarAtualizacaoAction
} = totalizadorSlice.actions